const isNonZero = (value) => Math.round(Number(value || 0) * 100) !== 0;

export const shouldIncludeClosingBalance = (row = {}) => {
  const closingBalance = Number(row.closingBalance || 0);
  const openingBalance = Number(row.openingBalance || 0);
  return (
    isNonZero(closingBalance) &&
    (closingBalance < 0 || row.isUnknown === true || openingBalance > 0)
  );
};

export const includedClosingBalanceRows = (rows = []) =>
  rows.filter(shouldIncludeClosingBalance);
